<div (click)="swapSlider()"
     *ngIf="wallet else loading"
     [class.select]="showWallet"
     class="wallet-head"
     data-action="showWallet">
    <label style="word-break: break-word">
        <i *ngIf="wallet.active" class="bi bi-bookmark-check-fill color174882"></i>
        <i *ngIf="!wallet.active" class="bi bi-bookmark-x-fill text-danger"></i>
        <i *ngIf="wallet.contract_guid" class="bi bi-calendar4-week text-success"
           title="{{ 'FINANCE.TEXT.CONTRACT' | translate }}"></i>
        {{ i + 1 }}: {{ wallet.title }}
    </label>
    <span *ngIf="structWalletsInfo[wallet.guid]" class="master_total">
        <span *ngIf="!(wallet.contract_guid && (structWalletsInfo[wallet.guid].expectedBlocked || structWalletsInfo[wallet.guid].promisedBlocked))">
            {{ wallet.total | currency : wallet.currency.currency_code : 'symbol' : '1.2-2' : 'ru' }}
        </span>
        <span *ngIf="wallet.contract_guid && (structWalletsInfo[wallet.guid].expectedBlocked || structWalletsInfo[wallet.guid].promisedBlocked)">

            <span *ngIf="structWalletsInfo[wallet.guid].expectedBlocked"
                  class="text-success"> +{{ structWalletsInfo[wallet.guid].expectedBlocked | currency : wallet.currency.currency_code : 'symbol' : '1.2-2' : 'ru' }} </span>
            <span *ngIf="structWalletsInfo[wallet.guid].expectedBlocked && structWalletsInfo[wallet.guid].promisedBlocked"> / </span>
            <span *ngIf="structWalletsInfo[wallet.guid].promisedBlocked"
                  class="text-danger"> -{{ structWalletsInfo[wallet.guid].promisedBlocked | currency : wallet.currency.currency_code : 'symbol' : '1.2-2' : 'ru' }} </span>
        </span>

        <i (click)="deleteWallet(wallet)" *ngIf="!wallet.contract_guid" class="bi bi-trash"
           data-action="deleteWallet"
           style="font-size: 20px; margin-left: 10px; color: red; cursor: pointer"></i>
    </span>
</div>

<!-- <div *ngIf="wallet && (structWalletsInfo[wallet.guid] && showWallet) else loadingSmall" -->
<div
        class="wallet-content">
    <div class="row p-2">
        <div class="col-9 p-4">
            <div class="totalPanel">
                <div class="financeTotalSum">
                    {{ wallet.total | currency : wallet.currency.currency_code : 'symbol' : '1.2-2' : 'ru' }}
                </div>
            </div>
        </div>

        <!-- ToDo  purse/project/profile Добавить в эндпоинт возможность получать кошельки заданного проекта-->
        <div class="col-3">
            <div class="btn-group-vertical w-100" [matTooltip]="'Проект не мастер. Операции не доступны'">
                <button (click)="onShowReplenishmentDialog()"
                        [disabled]="buttonsDisabled?.replenishment"
                        class="btn btn-light not_master "
                        data-action="showReplenishment"

                >
                    <i class="bi bi-box-arrow-in-down me-2"></i>
                    <span>{{ 'FINANCE.BUTTONS.TOP_UP' | translate }}</span>
                </button>
                <button (click)="onShowBarterDialog()"
                        [disabled]="buttonsDisabled?.barter"
                        class="btn btn-light not_master"
                        data-action="showBarter">
                    <i class="bi bi-arrow-left-right  me-2"></i>
                    <span>{{ 'FINANCE.BUTTONS.TRANSFER' | translate }}</span>
                </button>
                <button (click)="modalService.openTemplateModal(transactionView)"
                        [disabled]="buttonsDisabled?.payment"
                        class="btn btn-light not_master "
                        data-action="showTransaction">
                    <i class="bi bi-credit-card me-2"></i>
                    <span>{{ 'FINANCE.BUTTONS.PAY' | translate }}</span>
                </button>
                <button (click)="modalService.openTemplateModal(moreView)"
                        class="btn btn-light infoButton not_master"
                        data-action="showInfo">
                    <i class="bi bi-info-circle me-2"></i>
                    <span>{{ 'FINANCE.BUTTONS.MORE' | translate }}</span>
                </button>
                <button (click)="loadPaymentsHistory(wallet, historyWalletView)"
                        class="btn btn-light not_master"
                        data-action="showHistory">
                    <i class="bi bi-clock-history me-2"></i>
                    <span>{{ 'FINANCE.BUTTONS.HISTORY' | translate }}</span>
                </button>
                <button (click)="modalService.openTemplateModal(viewContract, 'xl')"
                        *ngIf="wallet.contract_guid && !contractView"
                        class="btn btn-light not_master"
                        data-action="openContract">
                    <i class="bi bi-calendar4-week"></i>
                    <span>{{ 'FINANCE.BUTTONS.CONTRACT' | translate }}</span>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- пополнение баланса -->
<ng-container *ngIf="isShowReplenishmentModal">
    <app-replenishment (emitFinish)="onCloseModal($event); isShowReplenishmentModal = false"
                       [wallet]="wallet">
    </app-replenishment>
</ng-container>

<!-- вывод денег -->
<ng-container *ngIf="isShowPayoutModal">
    <app-payout (emitFinish)="onCloseModal($event); isShowPayoutModal = false"
                [wallet]="wallet">
    </app-payout>
</ng-container>

<!-- перевод денег -->
<ng-container *ngIf="isShowBarterModal">
    <app-barter (emitFinish)="onCloseModal($event); isShowBarterModal = false"
                [isMaster]="changeMode"
                [masterWallet]="masterWallet"
                [outWallet]="wallet"
                [purse]="financeProfile">
    </app-barter>
</ng-container>

<ng-template #historyWalletView let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <app-payment-modal
                [detail]="false"
                [payments]="wallet.payments"
                [walletProjectGuid]="wallet.project_guid"
        ></app-payment-modal>
    </div>
</ng-template>

<ng-template #viewContract let-modal>
    <app-button-modal-close [modal]="modal" modalSize="xl"></app-button-modal-close>
    <div class="modal-body">
        <app-contract-detail
                [canEdit]="false"
                [contractGuid]="wallet.contract_guid"
                [isViewing]="true"
        ></app-contract-detail>
    </div>
</ng-template>

<ng-template #transactionView let-modal>
    <app-button-modal-close [modal]="modal" modalSize="lg"></app-button-modal-close>
    <div [innerHTML]="'MODALS.TEXT.PAY_ERROR' | translate"
         class="modal-body"
    ></div>
</ng-template>

<ng-template #moreView let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <div class="wallets" style="width: auto">
            <div class="wallet">
                <div class="wallet-content">
                    <div class="row" style="margin-top: 20px;">
                        <div class="col-6">
                            <ul class="list-payments">
                                <li class="promised">
                                    {{ 'MODALS.TEXT.PAYMENTS.EXPECTED_BLOCKED' | translate }}:
                                    + {{ structWalletsInfo[wallet.guid].expectedBlocked | currency : wallet.currency.currency_code : 'symbol' : '1.2-2' : 'ru' }}
                                </li>
                                <li class="def">
                                    {{ 'MODALS.TEXT.PAYMENTS.EXPECTED' | translate }}:
                                    + {{ structWalletsInfo[wallet.guid].expected | currency : wallet.currency.currency_code : 'symbol' : '1.2-2' : 'ru' }}
                                </li>
                            </ul>
                        </div>
                        <div class="col-6">
                            <ul class="list-payments">
                                <li class="expected">
                                    {{ 'MODALS.TEXT.PAYMENTS.PROMISED_BLOCKED' | translate }}:
                                    - {{ structWalletsInfo[wallet.guid].promisedBlocked | currency : wallet.currency.currency_code : 'symbol' : '1.2-2' : 'ru' }}
                                </li>
                                <li class="def">
                                    {{ 'MODALS.TEXT.PAYMENTS.PROMISED' | translate }}:
                                    - {{ structWalletsInfo[wallet.guid].promised | currency : wallet.currency.currency_code : 'symbol' : '1.2-2' : 'ru' }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="margin-left: 20px">
            <small>
                GUID: {{ wallet.guid }}<br>
                {{ 'MODALS.TEXT.LAST_TRANSACTION' | translate }}: {{ helper.formatDate(wallet.last_operation_at) }}<br>
                {{ 'MODALS.TEXT.CREATED' | translate }}: {{ helper.formatDate(wallet.created_at) }}
            </small>
        </div>
    </div>
</ng-template>

<ng-template #loading>
    <app-component-loading *ngIf="isLoadingData"></app-component-loading>
    <div *ngIf="isLoadingDataError" class="alert alert-danger">{{ 'CONNECTION_ERROR' | translate }}</div>
</ng-template>

<ng-template #loadingSmall>
    <app-component-loading *ngIf="isLoadingData" size="smail"></app-component-loading>
    <div *ngIf="isLoadingDataError" class="alert alert-danger">{{ 'CONNECTION_ERROR' | translate }}</div>
</ng-template>
